import { useQuery } from "react-query";
import { ChampionshipAPI } from "api/championship";
import { CHAMPIONSHIPS } from "helpers/constants";

export default function useAllAroundResults(competitionId) {
  return useQuery(
    [CHAMPIONSHIPS, competitionId, "allAround"],
    () => ChampionshipAPI.getAllAroundResultsForCompetition(competitionId),
    { enabled: !!competitionId }
  );
}
